module.exports = __webpack_public_path__ + "img/location.16a18192.svg";